<template>
  <v-sheet
    :color="$vuetify.theme.isDark ? '#4C4C4C33' : '#fff'"
    style="box-shadow: 0px 0px 20px 0px #0000000d"
    class="pa-3 rounded-lg">
    <v-card-title class="d-flex justify-space-between pa-0">
      <span class="font-weight-bold" style="color: var(--v-grey-500-base)">{{ title }}</span>
    </v-card-title>
    <v-sheet
      :color="'transparent'"
      :height="canvasHeight"
      class="d-flex justify-center align-center">
      <canvas
        ref="pressureGauge"
        style="width: 100%; max-width: 100%; height: auto; padding: 10px"></canvas>
    </v-sheet>
  </v-sheet>
</template>

<script>
  import Chart from 'chart.js/auto';

  const gaugeNeedle = {
    id: 'gaugeNeedle',
    afterDatasetsDraw(chart) {
      const { ctx, data } = chart;
      ctx.save();
      const xCenter = chart.getDatasetMeta(0).data[0].x;
      const yCenter = chart.getDatasetMeta(0).data[0].y;
      const innerRadius = chart.getDatasetMeta(0).data[0].innerRadius;
      const outerRadius = chart.getDatasetMeta(0).data[0].outerRadius;
      const widthSlice = (outerRadius - innerRadius) / 2;
      const radius = 7;
      const angle = Math.PI / 180;
      const needleValue = data.datasets[0].needleValue;

      //   const dataTotal = data.datasets[0].data.reduce((a, b) => a + b, 0);
      const circumference =
        (chart.getDatasetMeta(0).data[0].circumference / Math.PI / data.datasets[0].data[0]) *
        needleValue;

      // Needle
      ctx.translate(xCenter, yCenter);
      ctx.rotate(Math.PI * (circumference + 1.335));
      ctx.beginPath();
      ctx.strokeStyle = '#2B2B2B';
      ctx.fillStyle = '#2B2B2B';
      ctx.lineWidth = 1;
      ctx.moveTo(0 - radius, 0);
      ctx.lineTo(0, 0 - innerRadius - widthSlice);
      ctx.lineTo(0 + radius, 0);

      ctx.stroke();
      ctx.fill();

      // Needle Dot
      ctx.beginPath();
      ctx.arc(0, 0, radius, 0, angle * 360, false);
      ctx.fill();

      ctx.restore();
    },
  };

  const gaugeFlowMeter = {
    id: 'gaugeFlowMeter',
    afterDatasetsDraw(chart) {
      const { ctx, data } = chart;
      ctx.save();
      //   const needleValue = data.datasets[0].needleValue;
      const xCenter = chart.getDatasetMeta(0).data[0].x;
      const yCenter = chart.getDatasetMeta(0).data[0].y;

      ctx.font = 'bold 30px Poppins';
      ctx.fillStyle = 'grey';
      ctx.textAlign = 'center';
      ctx.fillText(`${data.datasets[0].mainValue}°`, xCenter, yCenter + 70);
    },
  };

  const gaugeChartNeedlePin = {
    id: 'gaugeChartNeedlePin',
    afterDatasetsDraw(chart) {
      //   const { ctx, data, chartArea : {top, bottom, left, right, width, height}, scales : {r} } = chart;
      const { ctx } = chart;
      ctx.save();
      //   const needleValue = data.datasets[0].needleValue;
      const xCenter = chart.getDatasetMeta(0).data[0].x;
      const yCenter = chart.getDatasetMeta(0).data[0].y;

      ctx.font = 'bold 11px Poppins';
      ctx.fillStyle = '#D9D9D9';
      ctx.textAlign = 'center';
      ctx.fillText('O', xCenter - 1, yCenter + 4);
    },
  };
  const indicatorRotate1 = {
    id: 'indicatorRotate1',
    afterDatasetsDraw(chart) {
      const { ctx, data } = chart;
      ctx.save();

      const xCenter = chart.getDatasetMeta(0).data[0].x;
      const yCenter = chart.getDatasetMeta(0).data[0].y;

      ctx.translate(xCenter, yCenter);
      ctx.rotate((-20 * Math.PI) / 240);
      ctx.font = 'bold 12px Poppins';
      ctx.fillText(`-    ${data.datasets[0].indicator1}`, -100, 25);
      ctx.fillText('-           ', -100, 25);

      ctx.restore();
    },
  };

  const indicatorRotate2 = {
    id: 'indicatorRotate2',
    afterDatasetsDraw(chart) {
      const { ctx, data } = chart;
      ctx.save();

      const xCenter = chart.getDatasetMeta(0).data[0].x;
      const yCenter = chart.getDatasetMeta(0).data[0].y;

      ctx.translate(xCenter, yCenter);
      ctx.rotate((40 * Math.PI) / 240);

      ctx.font = 'bold 14px Poppins';
      ctx.fillText(`-    ${data.datasets[0].indicator2}`, -95, 5);
      ctx.fillText('-         ', -95, 5);

      ctx.restore();
    },
  };

  const indicatorRotate3 = {
    id: 'indicatorRotate3',
    afterDatasetsDraw(chart) {
      const { ctx, data } = chart;
      ctx.save();

      const xCenter = chart.getDatasetMeta(0).data[0].x;
      const yCenter = chart.getDatasetMeta(0).data[0].y;

      ctx.translate(xCenter, yCenter);
      ctx.rotate((120 * Math.PI) / 240);

      ctx.font = 'bold 14px Poppins';
      ctx.fillText(`-   ${data.datasets[0].indicator3}`, -95, 5);
      ctx.fillText('-        ', -95, 5);

      ctx.restore();
    },
  };

  const indicatorRotate4 = {
    id: 'indicatorRotate4',
    afterDatasetsDraw(chart) {
      const { ctx, data } = chart;
      ctx.save();

      const xCenter = chart.getDatasetMeta(0).data[0].x;
      const yCenter = chart.getDatasetMeta(0).data[0].y;

      ctx.translate(xCenter, yCenter);
      ctx.rotate((-35 * Math.PI) / 240);

      ctx.font = 'bold 14px Poppins';
      ctx.fillText(`${data.datasets[0].indicator4}   -`, 95, 0);
      ctx.fillText('        -', 95, 0);

      ctx.restore();
    },
  };

  const indicatorRotate5 = {
    id: 'indicatorRotate5',
    afterDatasetsDraw(chart) {
      const { ctx, data } = chart;
      ctx.save();

      const xCenter = chart.getDatasetMeta(0).data[0].x;
      const yCenter = chart.getDatasetMeta(0).data[0].y;

      ctx.translate(xCenter, yCenter);
      ctx.rotate((20 * Math.PI) / 240);

      ctx.font = 'bold 14px Poppins';
      ctx.fillText(`${data.datasets[0].indicator5}   -`, 90, 25);
      ctx.fillText('        -', 90, 25);

      ctx.restore();
    },
  };

  export default {
    name: 'DoughnutChart',
    data() {
      return {
        chart: null,
      };
    },
    props: {
      title: String,
      canvasHeight: String,
      indicator1: {
        type: String,
        default: () => '',
      },
      indicator2: {
        type: String,
        default: () => '',
      },
      indicator3: {
        type: String,
        default: () => '',
      },
      indicator4: {
        type: String,
        default: () => '',
      },
      indicator5: {
        type: String,
        default: () => '',
      },
      needleValue: {
        type: Number,
        default: () => 0,
      },
      mainValue: {
        type: Number,
        default: () => 0,
      },
    },
    mounted() {
      this.createChart();
    },
    methods: {
      createChart() {
        const ctx = this.$refs.pressureGauge.getContext('2d');

        const gradient0 = ctx.createLinearGradient(0, 0, 240, 240);
        gradient0.addColorStop(0, '#759745');
        gradient0.addColorStop(1, '#ba9d12');

        const gradient1 = ctx.createLinearGradient(0, 0, 240, 240);
        gradient1.addColorStop(0, '#ba9d12');
        gradient1.addColorStop(1, '#D2A000');

        const gradient2 = ctx.createLinearGradient(0, 0, 240, 240);
        gradient2.addColorStop(0, '#D2A000');
        gradient2.addColorStop(1, '#be5400');

        const gradient3 = ctx.createLinearGradient(0, 0, 240, 240);
        gradient3.addColorStop(0, '#be5400');
        gradient3.addColorStop(1, '#A80000');

        this.chart = new Chart(ctx, {
          type: 'doughnut',
          data: {
            labels: ['SafeZone', 'Normal', 'UpNormal', 'Danger'],
            datasets: [
              {
                backgroundColor: [gradient0, gradient1, gradient2, gradient3],
                data: [25, 25, 25, 25],
                borderWidth: 0,
                borderSkipped: [false, false, false, false],
                borderRadius: [
                  { innerStart: 20, outerStart: 20 },
                  0,
                  0,
                  { innerEnd: 20, outerEnd: 20 },
                ],
                circumference: 240,
                rotation: 240,
                cutout: '80%',
                needleValue: this.needleValue,
                indicator1: this.indicator1,
                indicator2: this.indicator2,
                indicator3: this.indicator3,
                indicator4: this.indicator4,
                indicator5: this.indicator5,
                mainValue: this.mainValue,
              },
            ],
          },
          options: {
            responsive: true,
            maintainAspectRatio: false,
            aspectRatio: 1.6,
            plugins: {
              legend: {
                display: false,
              },
              tooltip: {
                enabled: false,
              },
            },
          },
          plugins: [
            gaugeNeedle,
            gaugeFlowMeter,
            gaugeChartNeedlePin,
            indicatorRotate1,
            indicatorRotate2,
            indicatorRotate3,
            indicatorRotate4,
            indicatorRotate5,
          ],
        });
      },
      getGradient(chart) {
        const {
          ctx,
          chartArea: { left, right },
        } = chart;
        const gradientSegment = ctx.createLinearGradient(left, 0, right, 0);
        gradientSegment.addColorStop(0, 'green');
        gradientSegment.addColorStop(0.5, 'orange');
        gradientSegment.addColorStop(1, 'red');
        return gradientSegment;
      },
    },
    beforeDestroy() {
      if (this.chart) {
        this.chart.destroy();
      }
    },
    watch: {
      needleValue: {
        handler: function (val) {
          this.chart.data.datasets[0].needleValue = val;
          this.chart.update();
        },
        deep: true,
      },
      mainValue: {
        handler: function (val) {
          this.chart.data.datasets[0].mainValue = val;
          this.chart.update();
        },
        deep: true,
      },
    },
  };
</script>
<style scoped>
  canvas {
    max-width: 100%;
  }
</style>
